import {NotificationMessageModel} from './notification-message.model';
import {ValidationModel} from '../../../shared/models/validation-results/validation.model';

export class NotificationBaseModel extends ValidationModel {
    message: NotificationMessageModel = new NotificationMessageModel();
    deliveryChannelTypeIds: number[] = new Array();
    constructor() {
        super('');
    }
}
